import { Button, IconText } from "@wac-ui-dashboard/wac_component_library";
import { limitStrLength } from "../../../utils/functions/table";
import useBulkUpload from "./useBulkUpload";
import Style from "./bulkUpload.module.scss";

const BulkUpload = ({ refetch, handleClose }) => {
  const {
    file,
    fileError,
    fileInputRef,
    isUploading,
    isDownloading,
    rowErrors,
    errorMessage,
    handleFileChange,
    handleUpload,
    handleSampleDownload,
    handleCancel,
  } = useBulkUpload({ refetch, handleClose });

  return (
    <form onSubmit={handleUpload} noValidate>
      <div className="pro-mb-4">
        <p className="pro-font-sm pro-mb-2">
          Upload an Excel sheet with one podcast per row. The audio and image
          files listed in the sheet must already be uploaded to the storage
          bucket. Rows are validated first: if any row has an error, no
          podcasts are created. Uploaded podcasts are added as inactive;
          activate each one from the list once its audio has been processed.
        </p>
        <button
          type="button"
          className={`pro-btn pro-btn-link pro-items-center pro-ps-0 ${Style.sample_btn}`}
          onClick={handleSampleDownload}
          disabled={isDownloading}
        >
          <span className="material-symbols-outlined">download</span>
          <span>{isDownloading ? "Downloading..." : "Download sample file"}</span>
        </button>
      </div>

      <div className="input-wrap pro-mb-4">
        <label htmlFor="bulk_upload_file" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Excel File*
        </label>
        <div className="input-drag">
          <input
            type="file"
            ref={fileInputRef}
            accept=".xlsx, .xls, .csv"
            className={`pro-input lg ${fileError && " error"}`}
            id="bulk_upload_file"
            name="file"
            onChange={handleFileChange}
          />
          <span className="input-drag-box">
            <IconText
              title={
                file?.name
                  ? limitStrLength(file.name, 30)
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {fileError && <span className="error-text">{fileError}</span>}
        </div>
        <span className="pro-font-xs pro-mt-1 pro-opacity-60">
          .xlsx, .xls or .csv, up to 10 MB
        </span>
      </div>

      {(rowErrors.length > 0 || errorMessage) && (
        <div className={`pro-mb-4 ${Style.errors}`}>
          <p className="pro-fw-medium pro-mb-1">{errorMessage}</p>
          {rowErrors.length > 0 && (
            <>
              <p className="pro-font-sm pro-mb-2">
                Fix these rows in the sheet and upload it again.
              </p>
              <ul className={Style.error_list}>
                {rowErrors.map((rowError) => (
                  <li key={rowError?.row}>
                    <span className="pro-fw-medium">Row {rowError?.row}</span>
                    <ul>
                      {Object.entries(rowError?.errors ?? {}).map(([field, message]) => (
                        <li key={field}>
                          <span className={Style.field}>{field}</span>: {message}
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}

      <div className="col-12 pro-mt-4 pro-d-flex pro-justify-end">
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleCancel} type="button">
          Cancel
        </Button>
        <Button className={"pro-btn-primary lg pro-mx-3"} type="submit" disabled={isUploading}>
          {isUploading ? "Uploading..." : "Upload"}
        </Button>
      </div>
    </form>
  );
};

export default BulkUpload;
